<template lang="pug">
    .settings(v-if='localSettings.length')
        template(v-for="(settings, index) in localSettings")
            span
                | {{ $i18n.t('trainer.trainer_gameFormSetting_category') }}: {{ $i18n.t(`trainer.trainer_gameFormSetting_${settings.category}`)  }}
            br
            span
                | {{ $i18n.t('trainer.trainer_gameFormSetting_rule') }}: {{ $i18n.t(`trainer.trainer_gameFormSetting_${settings.rule}`)  }}
            br
            span
                | {{ $i18n.t('trainer.trainer_gameFormSetting_showingCorrectAnswers') }}: {{ $i18n.t(settings.showingCorrectAnswers ? 'trainer.trainer_gameFormSettingValue_onAbbreviated' : 'trainer.trainer_gameFormSettingValue_offAbbreviated')  }}
            br
            template(v-if="settings.dueDate")
                span
                    | {{ $i18n.t('homework.homework_create_executeTime') }}:
                    | {{ getFormattedDate(settings.dueDate) }}
                br
            slot
</template>

<script>
    import TrainerUtilities from '../../../utils/trainer/trainer';
    import gamePreviewMixin from '../../../utils/trainer/gamePreviewMixin';
    import { getFormattedDate } from '../../../utils/getFormattedDate';

    export default {
        mixins: [TrainerUtilities, gamePreviewMixin],
        props: {
            game: Object,
            parameters: Object,
            userId: Number,
            parametersFrom: {
                type: String,
                default: 'homework',
            },
        },
        data() {
            return {
                localSettings: [],
            };
        },
        watch: {
            settings: {
                handler(val) {
                    this.localSettings = Array.isArray(val) ? val : [val];
                },
                immediate: true,
            },
        },
        methods: {
            getFormattedDate,
        },
    };
</script>
